import { createStyles } from '../../../styles/helpers'

export default createStyles({
  optionsWrapper: {
    padding: '0 3px'
  }
})
